export default __webpack_public_path__ + "static/media/DJI_0988.MP4.00_00_40_00.Still002.f1ec113f.jpg";